<template>
  <el-dropdown @command='handleCommand'>
    <el-popover
      placement='left'
      width='250'
      v-model='isPopoverVisible'>
      <p>Bạn có chắc muốn loại bỏ nguồn đã chọn?</p>
      <div style='text-align: right; margin: 0'>
        <el-button size='mini' type='text' @click='isPopoverVisible = false'>Hủy bỏ</el-button>
        <el-button type='primary' size='mini' @click='removeLink'>Xác nhận</el-button>
      </div>
      <el-button type='text' slot='reference' disabled style='cursor: pointer;'>
        <i style='color: #f00;' class='el-icon-delete el-icon--right'></i>
      </el-button>
    </el-popover>
    <el-dropdown-menu slot='dropdown'>
      <el-dropdown-item :command="{'type': IgnoredSourceType.URL, 'data': [sourceData.id]}">Loại bỏ nguồn
      </el-dropdown-item>
      <el-dropdown-item :command="{'type': IgnoredSourceType.DOMAIN, 'data': [sourceData.domain]}">Loại bỏ
        "{{ findHostName(sourceData) }}"
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { getHostName } from '@/helpers/StringHelper'
import { IgnoredSourceType } from '@/constants/DoITConstant'

export default {
  name: 'SourceItem',
  props: ['sourceData'],
  mounted() {
  },
  data: () => {
    return {
      isPopoverVisible: false,
      currentCommand: {},
      IgnoredSourceType
    }
  },
  methods: {
    handleCommand(command) {
      this.currentCommand = command
      this.isPopoverVisible = true
    },
    removeLink() {
      this.isPopoverVisible = false
      this.$emit('handle-command', this.currentCommand)
      this.currentCommand = {}
    },
    findHostName(source) {
      return getHostName(source)
    }
  }
}
</script>

<style>
.el-tree-node__label {
  margin-bottom: 7px;
}
</style>

<style scoped>

</style>
